import React from 'react';
import { connect } from 'react-redux';
import AdminShell, { Icon } from './AdminShell';
import { Fieldset, Field, FormActions, FormCard } from './Form';

/*
 * Configuration — layar `config` paket client.
 *
 * PROTOTIPE MENEBAK ISI LAYAR INI, DAN TEBAKANNYA HAMPIR SELURUHNYA MELESET.
 * Ia menggambar tujuh kotak: dokumen wajib per provider, masa berlaku OTP,
 * batas percobaan OTP, mode pemeliharaan, pendaftaran mandiri provider, dan
 * saklar introspeksi GraphQL. Tidak satu pun punya baris di SiteSettings —
 * sudah dicek langsung ke basis data. Kotak yang tidak menulis apa pun tidak
 * dibuat.
 *
 * Yang benar-benar tersimpan di sini justru yang prototipenya bilang tidak
 * boleh ada: kunci integrasi. Spanduk merahnya benar sebagai saran arsitektur
 * — kredensial memang lebih aman di environment variable — tapi hari ini
 * kesembilan nilai ini ada di tabel SiteSettings dan layar inilah satu-satunya
 * cara mengubahnya. Menyembunyikannya tidak memindahkannya, hanya membuatnya
 * tak terjangkau.
 *
 * DUA DARI SEMBILAN RAHASIA, DAN NILAINYA TIDAK PERNAH DIKIRIM KE SINI.
 * Password SMTP dan service account Firebase hanya dilaporkan terisi atau
 * tidak. Karena itu keduanya memakai pola "kosongkan untuk membiarkan":
 * kolomnya dibiarkan kosong berarti argumennya tidak dikirim sama sekali, dan
 * baris di basis data tidak disentuh. Sudah diuji: menyimpan perubahan pada
 * ukuran unggahan mengubah tepat satu baris dari 56, dan password SMTP maupun
 * kunci Firebase tetap sama persis.
 */

const gql = (query, variables) => fetch('/graphql', {
  method: 'post',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  body: JSON.stringify({ query, variables }),
  credentials: 'include'
}).then(r => r.json());

// Kesembilan field updateConfigSettings.
const PLAIN = ['smtpHost', 'smtpPort', 'smptEmail', 'smtpSender', 'smtpSenderEmail',
  'stripePublishableKey', 'maxUploadSize'];
const SECRET = ['smtpPassWord', 'fcmPushNotificationKey'];
const ALL = PLAIN.concat(SECRET);

const Q = `query ($names: [String]) {
  getAdminSiteSettings(names: $names) {
    status errorMessage
    results { name value isSecret isSet hint }
  }
}`;

const M = `mutation (${ALL.map(f => `$${f}: String`).join(', ')}) {
  updateConfigSettings(${ALL.map(f => `${f}: $${f}`).join(', ')}) {
    status errorMessage
  }
}`;

const M_TEST = `mutation { testSmtpConnection { status connected detail errorMessage } }`;

const ok = res => res && Number(res.status) === 200;

class Configuration extends React.Component {
  state = {
    values: {}, original: {}, secretState: {}, secretInput: {},
    errors: {}, loading: true, error: null, saving: false, testing: false, notice: null, smtp: null
  };

  componentDidMount() { this.load(); }

  isArabic = () => String(this.props.currentLocale || '').startsWith('ar');
  tx = (en, ar) => this.isArabic() ? ar : en;

  errorText = message => {
    if (!this.isArabic()) return message || 'Could not save the configuration.';
    const value = String(message || '').toLowerCase();
    if (value.includes('smtpport')) return 'يجب أن يكون منفذ SMTP رقماً صحيحاً من 1 إلى 65535.';
    if (value.includes('sender email')) return 'أدخل عنوان بريد إلكتروني صالحاً للمرسل.';
    if (value.includes('maxuploadsize')) return 'يجب أن يكون الحد الأقصى للرفع عدداً صحيحاً موجباً.';
    if (value.includes('stripe')) return 'أدخل مفتاح Stripe عاماً صالحاً.';
    if (value.includes('firebase')) return 'يجب أن تكون بيانات Firebase بصيغة JSON لحساب خدمة صالح.';
    return 'تعذّر حفظ الإعدادات.';
  };

  load = async () => {
    this.setState({ loading: true, error: null });
    const json = await gql(Q, { names: ALL }).catch(() => null);
    const res = json && json.data && json.data.getAdminSiteSettings;
    if (!ok(res)) {
      this.setState({ loading: false, error: this.isArabic()
        ? 'تعذّر تحميل الإعدادات.'
        : (res && res.errorMessage) || 'Could not load the configuration.' });
      return;
    }
    const values = {};
    const secretState = {};
    (res.results || []).forEach(r => {
      if (r.isSecret) secretState[r.name] = { isSet: r.isSet, hint: r.hint };
      else values[r.name] = r.value === null ? '' : r.value;
    });
    this.setState({
      values, original: { ...values }, secretState, secretInput: {}, errors: {},
      loading: false, smtp: null
    });
  };

  set = (name, value) => this.setState(st => ({
    values: { ...st.values, [name]: value }, errors: { ...st.errors, [name]: null }, notice: null
  }));

  setSecret = (name, value) => this.setState(st => ({
    secretInput: { ...st.secretInput, [name]: value }, errors: { ...st.errors, [name]: null }, notice: null
  }));

  dirty() {
    const { values, original, secretInput } = this.state;
    return PLAIN.some(k => (values[k] || '') !== (original[k] || ''))
      || SECRET.some(k => String(secretInput[k] || '').trim().length > 0);
  }

  reset = () => this.setState(st => ({
    values: { ...st.original }, secretInput: {}, errors: {}, notice: null
  }));

  /*
   * Kunci Firebase diperiksa di peramban sebelum dikirim. Pengirim notifikasi
   * memanggil JSON.parse pada nilai ini; kalau gagal, seluruh push mati tanpa
   * pesan galat di mana pun. Lebih baik ditolak di sini.
   */
  fcmError() {
    const raw = String(this.state.secretInput.fcmPushNotificationKey || '').trim();
    if (!raw) return null;
    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return this.tx('This is not valid JSON. Paste the whole service-account file, braces included.',
        'هذه ليست صيغة JSON صالحة. الصق ملف حساب الخدمة كاملاً مع الأقواس.');
    }
    if (!parsed || !parsed.project_id || !parsed.private_key) {
      return this.tx('Valid JSON, but it has no project_id and private_key — that is not a service-account file.',
        'صيغة JSON صالحة، لكنها لا تحتوي على project_id وprivate_key، لذا فهي ليست ملف حساب خدمة.');
    }
    return null;
  }

  validate() {
    const { values } = this.state;
    const errors = {};
    const required = this.tx('This field is required.', 'هذا الحقل مطلوب.');
    ['smtpHost', 'smtpPort', 'smptEmail', 'smtpSender', 'smtpSenderEmail',
      'stripePublishableKey', 'maxUploadSize'].forEach(name => {
      if (!String(values[name] || '').trim()) errors[name] = required;
    });
    const port = String(values.smtpPort || '').trim();
    if (port && (!/^\d+$/.test(port) || Number(port) < 1 || Number(port) > 65535)) {
      errors.smtpPort = this.tx('Enter a whole number from 1 to 65535.', 'أدخل عدداً صحيحاً من 1 إلى 65535.');
    }
    const email = String(values.smtpSenderEmail || '').trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.smtpSenderEmail = this.tx('Enter a valid email address.', 'أدخل عنوان بريد إلكتروني صالحاً.');
    }
    const size = String(values.maxUploadSize || '').trim();
    if (size && (!/^\d+$/.test(size) || Number(size) < 1)) {
      errors.maxUploadSize = this.tx('Enter a positive whole number.', 'أدخل عدداً صحيحاً موجباً.');
    }
    const stripe = String(values.stripePublishableKey || '').trim();
    if (stripe && !/^pk_(test|live)_[A-Za-z0-9]+$/.test(stripe)) {
      errors.stripePublishableKey = this.tx('Enter a valid Stripe publishable key.', 'أدخل مفتاح Stripe عاماً صالحاً.');
    }
    const fcm = this.fcmError();
    if (fcm) errors.fcmPushNotificationKey = fcm;
    return errors;
  }

  save = async () => {
    if (this.state.saving) return;
    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.setState({ errors, notice: {
        tone: 'danger', text: this.tx('Check the highlighted fields.', 'تحقق من الحقول المحددة.')
      } });
      return;
    }

    const { values, original, secretInput } = this.state;
    const vars = {};
    PLAIN.forEach(k => {
      if ((values[k] || '') !== (original[k] || '')) vars[k] = String(values[k]).trim();
    });
    // Rahasia hanya ikut kalau diketik ulang. Yang tidak dikirim dilewati server.
    SECRET.forEach(k => {
      const typed = String(secretInput[k] || '').trim();
      if (typed) vars[k] = typed;
    });

    this.setState({ saving: true, notice: null });
    const json = await gql(M, vars).catch(() => null);
    const res = json && json.data && json.data.updateConfigSettings;
    this.setState({ saving: false });

    if (!ok(res)) {
      this.setState({ notice: { tone: 'danger', text: this.errorText(res && res.errorMessage) } });
      return;
    }

    const changedFcm = !!vars.fcmPushNotificationKey;
    await this.load();
    this.setState({
      notice: {
        tone: 'info',
        text: changedFcm
          ? this.tx('Configuration saved. The Firebase key only takes effect after the server is restarted — it is read once when the first notification is sent.',
            'تم حفظ الإعدادات. لا يعمل مفتاح Firebase الجديد إلا بعد إعادة تشغيل الخادم، إذ تتم قراءته مرة واحدة عند إرسال أول إشعار.')
          : this.tx('Configuration saved. Mail settings take effect on the next email; no restart needed.',
            'تم حفظ الإعدادات. تُطبّق إعدادات البريد مع الرسالة التالية ولا تحتاج إلى إعادة تشغيل.')
      }
    });
  };

  test = async () => {
    this.setState({ testing: true, smtp: null, notice: null });
    const json = await gql(M_TEST, {}).catch(() => null);
    const res = json && json.data && json.data.testSmtpConnection;
    this.setState({ testing: false });
    if (!ok(res)) {
      this.setState({ notice: { tone: 'danger', text: this.isArabic()
        ? 'تعذّر اختبار اتصال SMTP.'
        : (res && res.errorMessage) || 'Could not run the test.' } });
      return;
    }
    this.setState({ smtp: { connected: res.connected, detail: res.detail } });
  };

  field = (name, label, props = {}) => (
    <Field label={label} hint={props.hint} error={this.state.errors[name]} span={props.span}
      required={props.required} htmlFor={`config-${name}`}>
      <input id={`config-${name}`} className={`inp${props.mono ? ' mono' : ''}`} type={props.type || 'text'}
        dir="auto" required={!!props.required} aria-invalid={!!this.state.errors[name]}
        value={this.state.values[name] || ''}
        placeholder={props.placeholder}
        onChange={e => this.set(name, e.target.value)} />
    </Field>
  );

  /*
   * Kolom rahasia. Kosong berarti "biarkan seperti sekarang"; itu keadaan
   * bawaannya, bukan penghapusan.
   */
  secretField = (name, label, props = {}) => {
    const st = this.state.secretState[name] || {};
    const typed = String(this.state.secretInput[name] || '').trim();
    return (
      <Field
        label={label}
        span={props.span}
        error={this.state.errors[name] || (name === 'fcmPushNotificationKey' && typed ? this.fcmError() : null)}
        hint={
          st.isSet
            ? this.tx(`Currently set — ${st.hint || 'value hidden'}. Leave blank to keep it.`,
              `مُعيّن حالياً — ${st.hint || 'القيمة مخفية'}. اترك الحقل فارغاً للاحتفاظ به.`)
            : this.tx('Not set. Nothing works until this is filled in.', 'غير مُعيّن. لن تعمل هذه الخدمة حتى تعبئة الحقل.')
        }
      >
        {props.textarea
          ? (
            <textarea className="inp mono" rows={props.rows || 5}
              value={this.state.secretInput[name] || ''}
              placeholder={props.placeholder}
              onChange={e => this.setSecret(name, e.target.value)} />
          )
          : (
            <input className="inp mono" type="password" autoComplete="new-password"
              value={this.state.secretInput[name] || ''}
              placeholder={props.placeholder}
              onChange={e => this.setSecret(name, e.target.value)} />
          )}
      </Field>
    );
  };

  render() {
    const { loading, error, saving, testing, notice, smtp, values, secretState } = this.state;
    const pk = String(values.stripePublishableKey || '');
    const pkMode = pk.indexOf('pk_live') === 0 ? 'live' : (pk.indexOf('pk_test') === 0 ? 'test' : null);

    return (
      <AdminShell
        current="config"
        breadcrumb={[this.tx('System', 'النظام'), this.tx('Configuration', 'الإعدادات')]}
        title={this.tx('Configuration', 'الإعدادات')}
        lead={this.tx('Mail, push and payment credentials, and the upload limit.',
          'بيانات اعتماد البريد والإشعارات والدفع والحد الأقصى للرفع.')}
        actions={[
          <a className="btn ghost" href="/siteadmin/settings/config" key="c">
            {this.tx('Open in classic', 'فتح النسخة الكلاسيكية')}
          </a>
        ]}
      >
        {notice && (
          <div className={`notice ${notice.tone}`} role={notice.tone === 'danger' ? 'alert' : 'status'}>
            <span className="ni">{notice.tone === 'danger' ? '!' : '✓'}</span>
            <span className="nt">{notice.text}</span>
            <button className="btn ghost sm" type="button"
              onClick={() => this.setState({ notice: null })}>{this.tx('Dismiss', 'إغلاق')}</button>
          </div>
        )}

        {/* Saran arsitektur prototipe, dinyatakan sebagai keadaan hari ini. */}
        <div className="notice warn">
          <span className="ni">!</span>
          <span className="nt">
            {this.tx(
              "These credentials live in a database row, not in the server's environment. Anyone who reaches this panel can change where the platform's mail and push notifications come from. Moving them to environment variables is worth doing; until then, this is the only screen that can edit them. Values marked hidden are never sent to your browser.",
              'بيانات الاعتماد هذه مخزنة في قاعدة البيانات وليست في بيئة الخادم. يستطيع من يصل إلى هذه اللوحة تغيير مصدر البريد والإشعارات. يُفضّل نقلها إلى متغيرات البيئة؛ وحتى ذلك الحين فهذه هي الشاشة الوحيدة لتعديلها. القيم المعلّمة كمخفية لا تُرسل أبداً إلى المتصفح.'
            )}
          </span>
        </div>

        {/* Yang diminta prototipe tapi tidak punya tempat penyimpanan. */}
        <div className="notice">
          <span className="ni">i</span>
          <span className="nt">
            {this.tx(
              'Maintenance mode, provider self sign-up, OTP validity and attempt limits, and required document counts are not stored anywhere in this system, so they cannot be set here. GraphQL introspection is not a setting either — it follows the build, and is off in production.',
              'لا يخزّن النظام وضع الصيانة أو التسجيل الذاتي لمقدم الخدمة أو مدة رمز التحقق وعدد محاولاته أو عدد المستندات المطلوبة، لذلك لا يمكن ضبطها هنا. كما أن استكشاف GraphQL يتبع نسخة البناء وليس إعداداً، وهو متوقف في بيئة الإنتاج.'
            )}
          </span>
        </div>

        {error && (
          <div className="notice danger" role="alert">
            <span className="ni">!</span><span className="nt">{error}</span>
            <button className="btn ghost sm" type="button" onClick={this.load}>
              {this.tx('Try again', 'إعادة المحاولة')}
            </button>
          </div>
        )}

        {loading
          ? <section className="card"><div className="card-b">{this.tx('Loading configuration…', 'جارٍ تحميل الإعدادات…')}</div></section>
          : !error && (
            <FormCard
              actions={
                <FormActions
                  note={this.tx('Blank secret fields are left untouched, not cleared', 'تُترك حقول الأسرار الفارغة كما هي ولا تُمسح')}
                  dirty={this.dirty()}
                  busy={saving}
                  onSave={this.save}
                  onCancel={this.reset}
                  saveLabel={this.tx('Save configuration', 'حفظ الإعدادات')}
                  cancelLabel={this.tx('Cancel', 'إلغاء')}
                  busyLabel={this.tx('Saving…', 'جارٍ الحفظ…')}
                />
              }
            >
              <Fieldset title={this.tx('Email (SMTP)', 'البريد الإلكتروني (SMTP)')}
                desc={this.tx('Every email the platform sends — receipts, password resets, invoices — goes through this one account.',
                  'تمر جميع رسائل المنصة، بما فيها الإيصالات وإعادة تعيين كلمة المرور والفواتير، عبر هذا الحساب.')}>
                {this.field('smtpHost', this.tx('Mail server host', 'خادم البريد'), { required: true, mono: true })}
                {this.field('smtpPort', this.tx('Port', 'المنفذ'), {
                  required: true, mono: true,
                  hint: this.tx('Port 465 uses TLS directly; anything else uses STARTTLS.', 'يستخدم المنفذ 465 اتصال TLS مباشراً، وتستخدم المنافذ الأخرى STARTTLS.')
                })}
                {this.field('smptEmail', this.tx('Username', 'اسم المستخدم'), {
                  required: true,
                  hint: this.tx('Usually the same as the sender address, but not always.', 'غالباً ما يطابق عنوان المرسل، لكن ليس دائماً.')
                })}
                {this.secretField('smtpPassWord', this.tx('Password', 'كلمة المرور'))}
                {this.field('smtpSender', this.tx('Sender name', 'اسم المرسل'), {
                  required: true,
                  hint: this.tx('The name recipients see in their inbox.', 'الاسم الذي يراه المستلمون في صندوق البريد.')
                })}
                {this.field('smtpSenderEmail', this.tx('Sender address', 'عنوان المرسل'), {
                  type: 'email', required: true,
                  hint: this.tx('Replies go here. It must be a domain this account is allowed to send as.', 'تصل الردود إلى هذا العنوان، ويجب أن يسمح الحساب بالإرسال من نطاقه.')
                })}

                {/*
                  * Tombol ini membuka sambungan dan login, lalu menutupnya.
                  * Tidak ada surat yang dikirim, jadi aman ditekan berkali-kali.
                  */}
                <div className="field span2">
                  <div className="setting-row">
                    <div className="txt">
                      <b>{this.tx('Check these credentials', 'اختبار بيانات الاعتماد')}</b>
                      <span>
                        {this.tx('Opens a connection and logs in. No email is sent. Save first — the test reads the stored values, not what is typed above.',
                          'يفتح اتصالاً ويسجل الدخول من دون إرسال بريد. احفظ أولاً، فالاختبار يقرأ القيم المخزنة وليس ما كُتب أعلاه.')}
                      </span>
                    </div>
                    <button className="btn ghost sm" type="button" onClick={this.test} disabled={testing}>
                      <Icon name="check" />{testing
                        ? this.tx('Checking…', 'جارٍ الاختبار…')
                        : this.tx('Test connection', 'اختبار الاتصال')}
                    </button>
                  </div>
                  {smtp && (
                    <div className={`notice ${smtp.connected ? '' : 'danger'}`} style={{ marginTop: 10 }}>
                      <span className="ni">{smtp.connected ? '✓' : '!'}</span>
                      <span className="nt">
                        {smtp.connected
                          ? this.tx('The mail server accepted these credentials.', 'قبل خادم البريد بيانات الاعتماد هذه.')
                          : this.tx('The mail server refused the connection.', 'رفض خادم البريد الاتصال.')}
                        {smtp.detail && <><br /><span className="mono">{smtp.detail}</span></>}
                        {!smtp.connected && String(smtp.detail || '').indexOf('535') >= 0 && (
                          <><br />{this.tx('A 535 means the username or password was rejected; the host and port are reachable. Check the account with the mail provider.',
                            'يعني الخطأ 535 رفض اسم المستخدم أو كلمة المرور، بينما الخادم والمنفذ متاحان. تحقق من الحساب لدى مزود البريد.')}</>
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </Fieldset>

              <Fieldset title={this.tx('Push notifications', 'الإشعارات الفورية')}
                desc={this.tx("The Firebase service account both apps' notifications are sent through.", 'حساب خدمة Firebase المستخدم لإرسال إشعارات التطبيقين.')}>
                {this.secretField('fcmPushNotificationKey', this.tx('Firebase service account (JSON)', 'حساب خدمة Firebase ‏(JSON)'), {
                  span: true, textarea: true, rows: 6,
                  placeholder: this.tx('Paste the whole downloaded service-account file to replace it', 'الصق ملف حساب الخدمة الذي نزّلته كاملاً لاستبداله')
                })}
                <div className="field span2">
                  <span className="hint">
                    {this.tx('This is the private key of a Google service account, not a server key. Replacing it needs a server restart before notifications use the new project — it is read once, when the first notification of the process is sent.',
                      'هذا مفتاح خاص لحساب خدمة Google وليس مفتاح خادم. يتطلب استبداله إعادة تشغيل الخادم قبل استخدام المشروع الجديد، لأنه يُقرأ مرة واحدة عند إرسال أول إشعار من العملية.')}
                  </span>
                </div>
              </Fieldset>

              <Fieldset title={this.tx('Payments', 'المدفوعات')}
                desc={this.tx('Only the publishable half of the Stripe pair is stored here.', 'يُخزّن هنا المفتاح العام فقط من زوج مفاتيح Stripe.')}>
                {this.field('stripePublishableKey', this.tx('Stripe publishable key', 'مفتاح Stripe العام'), {
                  span: true, mono: true, required: true, placeholder: 'pk_live_… / pk_test_…'
                })}
                <div className="field span2">
                  <span className="hint">
                    {pkMode
                      ? this.tx(`This is a ${pkMode} key. `, `هذا مفتاح وضع ${pkMode === 'live' ? 'الإنتاج' : 'الاختبار'}. `)
                      : this.tx('This does not look like a Stripe publishable key. ', 'لا تبدو هذه القيمة كمفتاح Stripe عام. ')}
                    {this.tx("The matching secret key is set in the server's environment and cannot be changed here. Both halves must be from the same account and the same mode — a live key paired with a test secret fails every payment.",
                      'يُضبط المفتاح السري المطابق في بيئة الخادم ولا يمكن تغييره هنا. يجب أن يكون المفتاحان من الحساب والوضع نفسيهما؛ فخلط مفتاح إنتاج بمفتاح اختبار يُفشل كل عملية دفع.')}
                  </span>
                </div>
              </Fieldset>

              <Fieldset title={this.tx('Uploads', 'رفع الملفات')}>
                {this.field('maxUploadSize', this.tx('Maximum upload size (MB)', 'الحد الأقصى للرفع (MB)'), { mono: true, required: true })}
                <div className="field">
                  <span className="hint">
                    {this.tx('Checked in the browser before a file is sent. The upload endpoint itself does not enforce it, so this stops honest mistakes, not deliberate ones.',
                      'يتحقق المتصفح من هذا الحد قبل إرسال الملف. نقطة الرفع نفسها لا تفرضه، لذا يمنع الأخطاء العادية لا المحاولات المتعمدة.')}
                  </span>
                </div>
              </Fieldset>

              {/* Rahasia yang ada di tabel yang sama tapi tidak dimiliki mutation ini. */}
              <Fieldset title={this.tx('Stored elsewhere', 'إعدادات مخزنة في مكان آخر')} rows>
                <div className="setting-row">
                  <div className="txt">
                    <b>{this.tx('Web push keys and the platform secret', 'مفاتيح إشعارات الويب وسر المنصة')}</b>
                    <span>
                      {this.tx('The VAPID key pair behind browser notifications on this dashboard, and the platform secret key, are in the same table but no screen edits them. They are changed directly in the database.',
                        'زوج مفاتيح VAPID لإشعارات المتصفح في هذه اللوحة ومفتاح المنصة السري موجودان في الجدول نفسه، لكن لا توجد شاشة لتعديلهِما. يتم تغييرهما مباشرة في قاعدة البيانات.')}
                    </span>
                  </div>
                </div>
                <div className="setting-row">
                  <div className="txt">
                    <b>{this.tx('OTP delivery', 'إرسال رمز التحقق')}</b>
                    <span>
                      {this.tx('Login codes are sent by the SMS gateway, not by email.', 'تُرسل رموز الدخول عبر بوابة الرسائل النصية وليس البريد الإلكتروني.')}
                      {secretState.smtpPassWord && !secretState.smtpPassWord.isSet
                        ? this.tx(' Email being down does not stop anyone signing in.', ' لا يمنع تعطل البريد المستخدمين من تسجيل الدخول.')
                        : ''}
                    </span>
                  </div>
                  <a className="btn ghost sm" href="/admin/sms-providers">
                    <Icon name="sms" />{this.tx('SMS providers', 'مزودو الرسائل النصية')}
                  </a>
                </div>
              </Fieldset>
            </FormCard>
          )}
      </AdminShell>
    );
  }
}

const mapState = state => ({ currentLocale: state && state.intl && state.intl.locale });

export default connect(mapState)(Configuration);
